module.exports = __webpack_public_path__ + "static/media/Mapa-Santa Catarina.414761d9.svg";